'use strict';

var lib = require('./lib-75591456.js');
var icon = require('./icon-e3ab87ed.js');

var CLOSE = 'M19 6.41924L13.4192 12L19 17.5808L17.5808 19L12 13.4192L6.41924 19L5 17.5808L10.5808 12L5 6.41924L6.41924 5L12 10.5808L17.5808 5L19 6.41924Z';
var IconClose = lib.variant('IconClose', icon.Icon, {
    path: CLOSE,
});

exports.CLOSE = CLOSE;
exports.IconClose = IconClose;
//# sourceMappingURL=index-814ab386.js.map
